import { exitReviewMode, getPrincipal, isReviewMode } from 'src/utils/auth';
import React, { FC, useEffect } from 'react';
import { flowMenuDataStore } from 'src/store/menu';
import { menuSet } from 'src/static/admin_menu';
import { useLocation } from 'react-router-dom';
import Template from './template';
import './template/style.scss';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';

interface Props {}
const Main: FC<Props> = () => {
  const { state } = useLocation();
  const query = new URLSearchParams(window.location.search);
  const coId = query.get('co_id') || '';

  const pageNum = state?.pageNum || 0;
  const setFlowMenuStore = flowMenuDataStore(state => state.set);
  useEffect(() => {
    const data = menuSet();
    // 임시 페이지 고정
    const chkFlag = true;
    data.forEach((item: any, idx: number) => {
      item.active = false;
      item.checked = false;
      if (pageNum >= idx) {
        item.checked = true;
        if (pageNum === idx) {
          item.active = true;
        }
      }
    });
    setFlowMenuStore({ page: data });
  }, [pageNum, coId]);

  return (
    <>
      {isReviewMode() && (
        <div role="status" style={{}}>
          <div className="_top_status_div">
            <div className="_label">
              관리자 <em>{getPrincipal()?.name} · </em>
              <em>{JSON.parse(sessionStorage.getItem('review_user') || '{}').name}</em> 검토 중
            </div>
            <div className="_btn">
              <DefaultButton
                text="검토 종료"
                clickEvent={exitReviewMode}
                styleDef={{ width: '80px', height: '28px', fontSize: '13px' }}
                type="type5"
              />
            </div>
          </div>
        </div>
      )}
      <Template />
    </>
  );
};

export default Main;
